import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  toggleAll(event) {
    this.checkboxTargets.forEach((target) => {
      target.checked = event.target.checked
    })
  }
}
